const MahimaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 300 200"
      width="190"
      height="127"
      fill="none"
    >
      <defs>
        <clipPath id="mahima-footer-clip">
          <rect x="-72.54" y="58.37" width="442.93" height="160.29" />
        </clipPath>
      </defs>
      <g clipPath="url(#mahima-footer-clip)">
        <path
          fill="#F2EEE6"
          d="M186.33,58.37c-2.69,0-4.93,2.23-4.93,4.92s2.24,4.92,4.93,4.92,4.92-2.23,4.92-4.92-2.23-4.92-4.92-4.92"
        />
        <path
          fill="#F2EEE6"
          d="M286.06,120.08v10.55c-.99.05-2.01.09-3,.12-43.97,1.82-89.26-8.1-124.46-35.18-7.09-4.66-17.86-14.41-26.65-11.16-10.7,3.42-10.72,20.12-22.46,22.59-10.58,1.61-17.15-9.61-22.05-16.96-5.3-8.32-11.06-17.87-18.23-24.54-1.7-1.58-2.91-2.05-3.86-2.11,0,0-.53-.03-1.08.06-5.24.99-5.73,11.41-11.88,26.7-2.01,4.99-3.86,8.64-4.81,10.41-2.51,4.75-5.59,10.49-11.18,16.75-6.17,6.93-11.71,10.33-13.01,11.12-1.64.98-3.06,1.72-4.06,2.21v-10.37c.86-.46,1.72-.98,2.54-1.53,6.51-4.15,11.47-9.89,16.55-16.89,4.98-6.73,8.99-14.11,12.1-21.96,2.63-6.09,3.83-11,7.1-17.08,1.33-2.5,4.47-4.75,7.56-4.38,8.45.83,14.51,11.99,18.83,18.31,2.31,3.67,4.63,7.3,7.15,10.74,3.61,4.84,7.44,9.95,12.74,12.55,3.12,1.32,5.47.79,7.62-1.91,2.44-3.11,4.22-7.25,6.72-10.7,4.1-6.28,11.99-10.81,19.65-9.14,4.79.98,8.72,3.57,12.52,6.25,10.35,7.81,20.81,15.37,32.47,20.94,31.72,15.66,68.33,19.64,103.13,14.61h.04Z"
        />
      </g>
    </svg>
  )
}

export default MahimaIcon
